import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../services/authentication.service";
import { AuthService } from "../../core/services/auth.service";
import { catchError, of } from "rxjs";
import { SnackbarService } from "../../services/snackbar.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  emailFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required])
  });
  passwordVisible = false;
  loading = false;

  constructor(
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    private snackbarService: SnackbarService
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.emailFormGroup.valid) {
      let email = this.emailFormGroup.get('email')?.value;
      let password = this.emailFormGroup.get('password')?.value;

      this.loading = true
      this.authService.logIn$(email, password)
        .pipe(catchError(err => {
          if (err.status === 401) {
            this.snackbarService.error("Helytelen email cím vagy jelszó!");
            this.markCredentialsIncorrect();
          } else {
            this.snackbarService.error("A belejentkezés során hiba lépett fel!");
          }
          return of();
        }))
        .subscribe();
    }
  }

  togglePasswordVisible() {
    this.passwordVisible = !this.passwordVisible;
  }

  private markCredentialsIncorrect() {
    this.emailFormGroup.get('email')?.setErrors({ 'incorrect': true });
    this.emailFormGroup.get('password')?.setErrors({ 'incorrect': true });
  }

  clearCredentialsIncorrect() {
    this.emailFormGroup.get('email')?.setErrors({ 'incorrect': null });
    this.emailFormGroup.get('email')?.updateValueAndValidity()
    this.emailFormGroup.get('password')?.setErrors({ 'incorrect': null });
    this.emailFormGroup.get('password')?.updateValueAndValidity()
  }

  areCredentialsIncorrect() {
    return this.emailFormGroup.get('email')?.hasError('incorrect')
      || this.emailFormGroup.get('password')?.hasError('incorrect');
  }
}
